import { withFocusable } from '../../hocs/Focusable/FocusableHOC';
import { ButtonNext as Button } from './button-next';
export var ButtonNext = withFocusable(Button);
//# sourceMappingURL=index.js.map